import { $window } from '../../../NonReact/common/AkixiWindow'

export const useReportPortalContainer = (): Nullable<HTMLElement> =>
    $window.m_bIsFullscreenActive ? document.getElementById('idRptsArea') : document.body
